module.exports = __webpack_public_path__ + "static/media/betgamestv.f93ace00.webp";